import {setCacheNameDetails as workbox_core_setCacheNameDetails} from 'M:/Meshkat/frontend/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'M:/Meshkat/frontend/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "Meshkat"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/app.925dad02.css",
    "revision": null
  },
  {
    "url": "/css/chunk-vendors.45a52ff5.css",
    "revision": null
  },
  {
    "url": "/fonts/BLotus.8c05c590.ttf",
    "revision": null
  },
  {
    "url": "/fonts/BLotusBd.13b135f3.ttf",
    "revision": null
  },
  {
    "url": "/fonts/Doran-ExtraBold.f61e8a42.woff2",
    "revision": null
  },
  {
    "url": "/fonts/Doran-Regular.0a54e279.woff2",
    "revision": null
  },
  {
    "url": "/img/0.258bb782.jpg",
    "revision": null
  },
  {
    "url": "/img/1.fbd3e4bf.jpg",
    "revision": null
  },
  {
    "url": "/img/2.98c984c6.jpg",
    "revision": null
  },
  {
    "url": "/img/3.b8bec7e9.jpg",
    "revision": null
  },
  {
    "url": "/img/4.6b341b0b.jpg",
    "revision": null
  },
  {
    "url": "/img/404Picture.png",
    "revision": "f7f4997aedfdefe6af4479015126233b"
  },
  {
    "url": "/img/5.994bb779.jpg",
    "revision": null
  },
  {
    "url": "/img/6.6512c847.jpg",
    "revision": null
  },
  {
    "url": "/img/7.ce370f2f.jpg",
    "revision": null
  },
  {
    "url": "/img/8.b00a65ee.jpg",
    "revision": null
  },
  {
    "url": "/img/9.8bfb282e.jpg",
    "revision": null
  },
  {
    "url": "/img/ali-ibn-musa.f999ff64.jpg",
    "revision": null
  },
  {
    "url": "/img/emam-agha.efc41274.png",
    "revision": null
  },
  {
    "url": "/img/icon-2.5c84f163.png",
    "revision": null
  },
  {
    "url": "/img/icon-4.67d1e4fb.png",
    "revision": null
  },
  {
    "url": "/img/imam-javad.898062d8.jpg",
    "revision": null
  },
  {
    "url": "/img/imam-kazem.898062d8.jpg",
    "revision": null
  },
  {
    "url": "/img/imam-sadeq.898062d8.jpg",
    "revision": null
  },
  {
    "url": "/img/lifestyle.3720a11b.png",
    "revision": null
  },
  {
    "url": "/img/logo-header.582cb4ac.png",
    "revision": null
  },
  {
    "url": "/img/markaz-qom.ded47aee.jpg",
    "revision": null
  },
  {
    "url": "/img/markaz-tehran.da032e45.jpg",
    "revision": null
  },
  {
    "url": "/img/pic-test.fdb52a20.jpg",
    "revision": null
  },
  {
    "url": "/img/sadr.3ba2c9f4.jpg",
    "revision": null
  },
  {
    "url": "/img/women-qom.3ba2c9f4.jpg",
    "revision": null
  },
  {
    "url": "/img/women-tehran.3ba2c9f4.jpg",
    "revision": null
  },
  {
    "url": "/index-v2.html",
    "revision": "d9eb978a7ae03b7111348edf897bbc6a"
  },
  {
    "url": "/jquery.js",
    "revision": "0208b96062ba59d07c4495115d2b42ce"
  },
  {
    "url": "/js/app.45a23af3.js",
    "revision": null
  },
  {
    "url": "/js/chunk-vendors.d1bb37f5.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "174df9eb564cb66f9901674c53a128c0"
  },
  {
    "url": "/pow-ui.js",
    "revision": "90cc9313c55b658ac892e29a5a7480a0"
  },
  {
    "url": "/robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  }
], {});








